import { Box, useTheme } from '@mui/material';
import RichText, { RichTextContent } from '../../../RichText';

type Props = {
  title: RichTextContent;
  isOpen: boolean;
  onClick: () => void;
};

const ServiceElement = ({ title, isOpen, onClick }: Props) => {
  const theme = useTheme();
  const borderColor = isOpen ? 'background.paper' : 'text.primary';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'stretch',
        height: '100%',
        transition: theme.transitions.create('all', {
          duration: theme.transitions.duration.shortest,
        }),
      }}
    >
      <Box
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          height: '100%',
          bgcolor: isOpen ? 'background.paper' : 'background.default',
          color: 'text.primary',
          cursor: 'pointer',
          borderTop: `1px solid ${borderColor}`,
          borderRight: `1px solid ${borderColor}`,
          '& h3::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            height: '4px',
            width: 0,
            bgcolor: 'secondary.main',
            transition: theme.transitions.create('width', {
              duration: theme.transitions.duration.shortest,
            }),
          },
          '&:hover  h3::after': {
            height: '4px',
            width: '70%',
          },
        }}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
        onClick={onClick}
      >
        <RichText
          withTypography
          variant={'h2'}
          component={'h3'}
          sx={{
            position: 'relative',
          }}
        >
          {title}
        </RichText>
      </Box>
    </Box>
  );
};

export default ServiceElement;
